import React, { useEffect, useState } from "react";
import styles from "../../BorrowerDetails.module.css";
import axios from "axios";
import { url } from "../../../../../App";
import { ToastContainer, toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import Cookies from 'js-cookie';

const RepaymentsModal = ({
  closeModal,
  loanData = {},
  openLoader,
  closeLoader,
}) => {
  const [repaymentArr, setRepaymentArr] = useState([]);
  useEffect(() => {
    const loanRepaymentHandler = async () => {
      try {
        openLoader();
        const req = {
          token: Cookies.get('Token'),
          email: Cookies.get('Email'),
          loan_id: loanData.loan_id,
        };
        const res = await axios.post(url + "/loan/repayment", req);

        if (!res.data.auth) {
          closeLoader();
          toast.error(res.data?.message);
          return null;
        }
        if (res.data?.message.msg) {
          closeLoader();
          toast.error(res.data.message.msg);
          return null;
        }
        closeLoader();
        setRepaymentArr(res.data?.message);
      } catch (err) {
        closeLoader();
        console.log(err);
        return null;
      }
    };
    loanRepaymentHandler();
    //eslint-disable-next-line
  }, [loanData.loan_id]);

  // console.log(loanData);

  // console.log(repaymentArr);

  // const memoizedRepaymentArr = useMemo(() => {
  //   return repaymentArr?.map((data, index) => {

  //     return (

  //     );
  //   });
  // }, [repaymentArr]);

  return (
    <>
      <ToastContainer />
      <div className={styles.repaymentModal}>
        <div
          className={styles.repaymentModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div className={styles.repaymentModalContent}>
            <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
            <h2>Repayments</h2>
            <div>
              <table>
                <thead>
                  <tr>
                    <th>EMI DATE</th>
                    <th>EMI AMOUNT</th>
                    <th>PRINCIPAL AMOUNT</th>
                    <th>INTEREST AMOUNT</th>
                    <th>EMI STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  {repaymentArr?.map((data, index) => {

                    /*
                    const apiDate = data?.emiDate
                      ? data.emiDate.split("T")[0]
                      : "";
                    const formattedDate = apiDate.split("-");
                    */

                    let dateStr = data?.emiDate || data?.dueDate || "";
                    let formattedDate = "";

                    if (dateStr.includes("T")) {
                      // Format like "2025-01-05T00:00:00.000Z"
                      const [year, month, day] = dateStr.split("T")[0].split("-");
                      formattedDate = `${day}-${month}-${year}`;
                    } else if (dateStr.includes("-")) {
                      // Format like "2024-12-05"
                      const [year, month, day] = dateStr.split("-");
                      formattedDate = `${day}-${month}-${year}`;
                    }
                    return (
                      <tr key={index}>
                        {/* <td>{`${formattedDate[2]}-${formattedDate[1]}-${formattedDate[0]}`}</td> */}
                        <td>{formattedDate}</td>
                        <td>{data.emiAmount}</td>
                        <td>{data.principalAmount}</td>
                        <td>{data.interestAmount}</td>
                        <td>{data.emiStatus}</td>
                      </tr>
                    );
                  })}
                </tbody>
                {/* <tbody>{memoizedRepaymentArr}</tbody> */}
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RepaymentsModal;
